module.exports = __webpack_public_path__ + "static/media/edit.70e18d31.svg";